<template>
    <div>
        <v-app-bar flat color="rgba(0, 0, 0, 0)">
            <v-toolbar-title>
                <v-chip
                    v-if="chart.nuevo"
                    color="primary"
                    outlined
                    label
                    x-small
                >
                    Nuevo
                </v-chip>
                {{ chart.options.chart.title }}
                <v-tooltip
                    v-model="showTooltip"
                    top
                    v-if="chart.anotacion?.length > 0"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            small
                        >
                        <v-icon>
                            mdi-information-outline
                        </v-icon>
                        </v-btn>
                    </template>
                    <span>
                        {{ chart.anotacion }}
                    </span>
                    </v-tooltip>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-if="displayZoom">
                <v-icon @click="$emit('zoom')">mdi-magnify-plus-outline</v-icon>
            </v-btn>
        </v-app-bar>
        <v-card-text class="pt-0">
            <v-row>
                <v-col cols="12">
                    <VueApexCharts v-if="renderChart"  :type="chartLocal.options.chart.type" :options="chartLocal.options" :series="chartLocal.options.series" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    {{ chartLocal.comentarios }}
                </v-col>
            </v-row>
        </v-card-text>
    </div>

</template>
<script>
    import VueApexCharts from 'vue-apexcharts'
    import es from "apexcharts/dist/locales/es.json";
    export default {
        name: "ChartContainer",
        components: {
            VueApexCharts
        },
        props: {
            displayZoom: {
                type: Boolean,
                default: true,
            },
            chart: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                showTooltip: false,
                renderChart: false,
                chartLocal: {}
            }
        },
        mounted(){
            this.chartLocal = this.chart
            this.chartLocal.options.chart.locales = [es]
            this.chartLocal.options.chart.defaultLocale = "es"
        },
        created() {
            this.$nextTick(() => { //workaround resolver problema width no se ajusta al 100% si no se hace resize de la pantalla
                this.renderChart = true
            })
        },
        methods: {

        },
        computed: {
            
        }
    }
</script>
<style>
    
</style>
